import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HelpfulTipsHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/helpful-tips/helpful-tips-hero-section';
import { HelpfulTipsContent } from '@trashlab/sitesapp/src/templates/redebins/components/helpful-tips/helpful-tips-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const HelpfulTipsPage = () => {
  return (
    <>
      <HelpfulTipsHeroSection />
      <HelpfulTipsContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dumpster-rental-guide',
  component: HelpfulTipsPage,
});

